import React from "react";
import { useMatch } from "react-router-dom";
import { WEB_ROUTES } from "../routes/web-routes";
import Header from "../components/header";
import Footer from "../components/footer";
import { Helmet } from "react-helmet";
import { useUtilities } from "../hooks/utilities";
import { useGalleryData } from "../hooks/useGalleryData";
import { useLightbox } from "../hooks/useLightbox";
import GalleryContent from "../components/GalleryContent";
import GalleryLightbox from "../components/GalleryLightbox";

export default function GallerySingle() {
  const singleGallery = useMatch(WEB_ROUTES.GALLERY + "/:gallery");
  const { getMetaSnippet } = useUtilities();

  const { gallery, loading, error } = useGalleryData(
    singleGallery?.params?.gallery
  );
  const { open, currentImage, slides, closeLightbox } = useLightbox(gallery);

  if (loading) {
    return (
      <>
        <Header />
        <main className="container mx-auto py-16 text-center">
          <p>Loading gallery...</p>
        </main>
        <Footer />
      </>
    );
  }

  if (error) {
    return (
      <>
        <Header />
        <main className="container mx-auto py-16 text-center">
          <p>Error loading gallery. Please try again later.</p>
        </main>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Helmet>
        <title>{gallery?.title?.rendered + ` - Nant Power`}</title>
        <meta
          name="description"
          content={getMetaSnippet(gallery?.content?.rendered)}
        />
      </Helmet>

      <Header />

      <main>
        <GalleryContent gallery={gallery} />
        <GalleryLightbox
          open={open}
          currentImage={currentImage}
          slides={slides}
          onClose={closeLightbox}
        />
      </main>

      <Footer />
    </>
  );
}
